import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import {
  withTolgee,
  Tolgee,
  DevTools,
  I18nextPlugin,
  BackendFetch,
} from '@tolgee/i18next';
import { AVAILABLE_LANGUAGES_CODES } from '@activepieces/shared';

const tolgee = Tolgee()
  // .use(DevTools()) // Disabled: crashes when pieces don't have all translations available in Tolgee
  .use(I18nextPlugin())
  .use(BackendFetch())
  .init({
    availableLanguages: AVAILABLE_LANGUAGES_CODES,
    apiUrl: import.meta.env.VITE_APP_TOLGEE_API_URL,
    apiKey: import.meta.env.VITE_APP_TOLGEE_API_KEY,
    projectId: import.meta.env.VITE_APP_TOLGEE_PROJECT_ID,
    fallbackLanguage: 'en',
    defaultLanguage: 'en',
  });

withTolgee(i18n, tolgee)
  .use(ICU)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    keySeparator: false,
    nsSeparator: false, // System messages may contain ':' — never treat it as a namespace // Disable dot notation to allow keys with dots (e.g., "1. Sign in...")
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    ns: ['common'],
    defaultNS: 'common',
    supportedLngs: AVAILABLE_LANGUAGES_CODES,
  });

export default i18n;
